import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import {
  VisitorBlacklist,
  VisitorBlacklistRequest,
} from 'src/app/models/dtos/access-controller/visitor-blacklist';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VisitorBlacklistService {
  env: string = environment.apiHost + '/api-core/secure/visitor-blacklist';
  constructor(private http: HttpClient) {}

  add(request: VisitorBlacklistRequest): Observable<VisitorBlacklist> {
    return this.http
      .post(this.env, request)
      .pipe(map((response: any) => response as VisitorBlacklist));
  }

  list(search?: string): Observable<VisitorBlacklist[]> {
    let params = new HttpParams();
    if (search) {
      params = params.set('search', search);
    }
    return this.http
      .get(this.env, { params })
      .pipe(map((response: any) => response as VisitorBlacklist[]));
  }

  remove(id: number): Observable<VisitorBlacklist> {
    return this.http
      .post(this.env + '/cancel/' + id, {})
      .pipe(map((response: any) => response as VisitorBlacklist));
  }
}
